import { useTranslation } from 'next-i18next';

import { BadgeBackgroundColor, BadgeBorderColor, BANNER_TYPE } from '@/types';

import Banner from '@/components/common/Banner';
import Divider from '@/components/common/Divider';
import AvailabilityBadge from '@/components/common/badge/AvailabilityBadge';

import styles from './ModalChangeStoreForDeliveryCountry.module.scss';

export const ModalChangeStoreForDeliveryCountry = ({ productsUnavailable, isCheckout = false }) => {
  const t = useTranslation().t;

  return (
    <div className={styles.container}>
      {isCheckout && (
        <>
          <Banner type={BANNER_TYPE.WARNING} content={t('selectDeliveryCountryRedirectModal.banner')} />
          <span dangerouslySetInnerHTML={{ __html: t('selectDeliveryCountryRedirectModal.description') }} />
        </>
      )}

      {isCheckout && productsUnavailable.length > 0 && <Divider />}

      {productsUnavailable.length > 0 && (
        <>
          <AvailabilityBadge
            background={BadgeBackgroundColor.CAUTION}
            border={BadgeBorderColor.WHITE}
            label={t('selectDeliveryCountryRedirectModal.titleUnavailableProduct')}
          />
          <span>{t('selectDeliveryCountryRedirectModal.descriptionUnavailableProduct')}</span>
          <div className={styles['product-unavailable-list']}>
            {productsUnavailable.map((product) => (<span key={product}>{product}</span>))}
          </div>
        </>
      )}
    </div>
  );
};

export default ModalChangeStoreForDeliveryCountry;
